import { get } from 'lodash';

import CARRIERS from '../../../../constants/operating-carriers';
import FARES from '../../../../constants/fare-types';
import REGIONS from '../../../../constants/region-type';

export default ({
  cart,
  confirmationModel,
  flightItineraryType,
  legCollection,
  pnrCode,
  products = [],
  userProfile,
  productsCP,
  CPflights,
}, wasPnrHold, cartOnHold) => {
  const {
    travelerCollection,
  } = cart;

  const totalPaied = get(confirmationModel, 'cartConfirmation.total', null);

  const cards = confirmationModel.paymentSummary.map(payment => {
    if (payment.cardType !== undefined) {
      return payment.cardType;
    }
    if (payment.cardType === undefined) {
      return payment.voucher !== undefined ? 'EMD Voucher' : 'UATP';
    }
  });

  const cardType = cards.join(' | ');
  const numberOfTravelers = travelerCollection.length;
  const isRoundTrip = flightItineraryType && flightItineraryType === 'ROUNDTRIP';
  const flightItineraryName = flightItineraryType === 'ONEWAY' ? 'OW' : 'MC';
  const flightType = isRoundTrip ? 'RT-' : flightItineraryName;

  if (wasPnrHold) {
    const priceByLeg = cartOnHold.getCostByLegForOnHold(legCollection.length);

    legCollection.forEach((leg, index)=>{
      const segments = leg.segmentsCollection;
      const totalSgmentsByLeg = segments.length;
      const marketingCarrier = totalSgmentsByLeg ? segments[0].marketingCarrier : 'AM';
      const legDepartureArrive = `${segments[0].departureAirport}-${segments[(totalSgmentsByLeg - 1)].arrivalAirport}`;
      const travelersCode = cartOnHold && cartOnHold.travelersCode ? cartOnHold.travelersCode : 'A1_C0_I0_PH0_PC0';
      const fareFamily = totalSgmentsByLeg ? segments[0].fareFamily : 'NA';
      const arrivalSegmentName = index === 0 ? 'IDA' : 'VUELTA';
      const arrivalSegment = !isRoundTrip ? '' : arrivalSegmentName;
      const flightNumbers = [];
      let marketingFlight = REGIONS.REGIONS_OF_FLIGHT[leg.marketFlight];

      const timeToDeparture = segments[0].departureDateTime.format('YYYYMMDDHHmm');
      const timeToArrive    = segments[(totalSgmentsByLeg - 1)].arrivalDateTime.format('YYYYMMDDHHmm');
      const aircraftType = segments[0].aircraftType;

      if ( marketingFlight === 'Transborder' ) {
        marketingFlight += leg.regionKey && leg.regionKey === 'USA' ? ' US' : ' CA';
      }

      segments.forEach((segment) => {
        flightNumbers.push(segment.marketingFlightCode);
      });

      const flightItineraryTypeName = flightItineraryType === 'ONEWAY' ? 'One Way' : 'Multi-city';

      products.push({
        name: isRoundTrip ? 'Round Trip' : flightItineraryTypeName,
        id: legDepartureArrive,
        price: priceByLeg,
        brand: CARRIERS[marketingCarrier],
        category: `Flight/Flight/${legDepartureArrive}/${travelersCode}|${timeToDeparture}:${timeToArrive}|${FARES.FARE_FAMILIES_NAMES[fareFamily]}|${(flightType + arrivalSegment)}|${( flightNumbers.join(':') )}/${marketingFlight}|${aircraftType}`,
        variant: get(confirmationModel, 'transactionId', 'NA'),
        quantity: numberOfTravelers,
      });
    });
  }

  const taxTotal = totalPaied.totalTax;

  const uniqueTypeofPayment = confirmationModel.hasTicketedAncillary() || confirmationModel.hasTicketedSeat() ? 'Money' : 'Points';
  const typeofPayment = (confirmationModel.hasTicketedAncillary() || confirmationModel.hasTicketedSeat()) && (confirmationModel.hasTicketedAncillaryPP() || confirmationModel.hasTicketedSeatPP()) ? 'With points and money' : uniqueTypeofPayment;

  const actionField = {
    id: 'NA',
    affiliation: 'MYB',
    revenue: 0,
    tax: 0,
    action: 'purchase',
  };

  const wasPnrHoldConditional = wasPnrHold ? totalPaied.totalTax : taxTotal;

  if (totalPaied) {
    actionField.id = `${pnrCode}-${confirmationModel.transactionTime.format('YYYYMMDDHHmm')}`;
    actionField.revenue = totalPaied.total;
    actionField.tax = (typeofPayment === 'Points') ? 0 : wasPnrHoldConditional;
  }

  let emdValueArray = [];

  try {
    if (products) {
      products.forEach(emdItem => {
        if (emdItem && emdItem.variant) {
          emdValueArray = emdValueArray.concat(emdItem.variant);
        }
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  return userProfile.hasOwnProperty('ffNumber') ? {
    event: 'purchase_v1',
    paymentForm: cardType,
    typeofPayment,
    clubpremierIDP: userProfile.hasOwnProperty('ffNumber') ? userProfile.ffNumber : '',
    pointsValue: confirmationModel.cartConfirmation.total.totalCPPoints, // Valor en puntos totales
    revenueMYB: totalPaied,
    pnr: pnrCode,
    numPax: numberOfTravelers,
    Cpmis: productsCP,
    CPflights,
    emdValue: emdValueArray,
    ecommerce: {
      currencyCode: totalPaied ? totalPaied.currencyCode : 'NA',
      purchase: {
        actionField: actionField,
        products: products,
      },
    },
  } : {
    event: 'purchase_v1',
    paymentForm: cardType,
    emdValue: emdValueArray,
    ecommerce: {
      currencyCode: totalPaied ? totalPaied.currencyCode : 'NA',
      purchase: {
        actionField: actionField,
        products: products,
      },
    },
  };
};
